import {utc} from 'moment/moment';

export function utcToLocalDatetimeFilter(date: string): string {
  if (!date) return '';
  return utc(date).local().format('YYYY-MM-DD HH:mm:ss');
}
